<header>Forgot Password</header>
<div class="header-text">No worries if you forgot your password, we'll help you reset it!</div>

<form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
  <div class="email">
    <mat-form-field appearance="outline">
      <mat-label>Email address</mat-label>
      <input matInput id="email" type="email" formControlName="email" />
      <mat-error *ngIf="email?.errors">Please enter a valid email address.</mat-error>
    </mat-form-field>
  </div>

  <button mat-flat-button color="primary" type="submit"
          [disabled]="forgotPasswordForm.invalid">Reset Password</button>
</form>

<button class="google-login" (click)="authService.googleLogin()" type="button">
  <img class="button-icon" src="assets/imgs/GoogleIcon.webp" alt="Google Logo" /><span>Login with Google</span>
</button>

<div class="login">
  Remember your password?
  <a class="login-button" [routerLink]="nav_path.signIn" rel="noreferrer">Sign In</a>
</div>

<div class="sign-up">
  Don't have an account?
  <a class="sign-up-button" [routerLink]="nav_path.signUp" rel="noreferrer">Sign Up</a>
</div>
